export const hasBgtRoute = (isAuth, user, isStudent) => {
    if (isAuth === null)
        return null

    return (
        window.config?.matriculationTab &&
        window.config?.matriculationTab?.show &&
        (isStudent &&
            (user?.studentkita >= window.config?.matriculationTab?.minStudentkita &&
                user?.studentkita <= window.config?.matriculationTab?.maxStudentkita)
        )
    )
}

export const hasRealisticIsraelRoute = (isAuth, user, isStudent, realisticIsrael) => {
    if (isAuth !== true || !user || !realisticIsrael?.classes)
        return null

    return (isStudent && realisticIsrael?.classes?.includes(Number(user?.studentkita)))
}